export const typeResourceEnum = {
  document: {
    symbol: 'general',
    label: 'Documento',
    color: 'primary',
    format: {
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/msword': ['.doc'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    },
  },
  xapi: {
    symbol: 'xapi',
    label: 'xApi',
    color: 'warning',
    format: {
      'application/zip': ['.zip'],
      'application/x-rar-compressed': ['.rar'],
    },
  },
  pdf: {
    symbol: 'pdf',
    label: 'PDF',
    color: 'error',
    format: { 'application/pdf': ['.pdf'] },
  },
  video: {
    symbol: 'video',
    label: 'Video',
    color: 'info',
    format: { 'video/mp4': ['.mp4'] },
  },
};

export const typeDownloadEnum = {
  zip: {
    symbol: 'ZIP',
    label: 'Zip',
    color: 'warning',
    format: 'application/zip',
    extension: 'zip',
  },
  txt: {
    symbol: 'TXT',
    label: 'Text',
    color: 'primary',
    format: 'plain/text',
    extension: 'txt',
  },
  docx: {
    symbol: 'DOCX',
    label: 'Word',
    color: 'info',
    format: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extension: 'docx',
  },
  xlsx: {
    symbol: 'XLSX',
    label: 'Excel',
    color: 'success',
    format: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extension: 'xlsx',
  },
  csv: {
    symbol: 'CSV',
    label: 'CSV',
    color: 'primary',
    format: 'text/csv',
    extension: 'csv',
  },
  html: {
    symbol: 'HTML',
    label: 'HTML',
    color: 'warning',
    format: 'text/html',
    extension: 'html',
  },
  pdf: {
    symbol: 'PDF',
    label: 'PDF',
    color: 'error',
    format: 'application/pdf',
    extension: 'pdf',
  },
};
